import { render, staticRenderFns } from "./WaningOutOfTestFocusModal.vue?vue&type=template&id=1b5680e0&scoped=true&"
import script from "./WaningOutOfTestFocusModal.vue?vue&type=script&lang=js&"
export * from "./WaningOutOfTestFocusModal.vue?vue&type=script&lang=js&"
import style0 from "./WaningOutOfTestFocusModal.vue?vue&type=style&index=0&id=1b5680e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5680e0",
  null
  
)

export default component.exports